import URLParser from 'helpers/urlParser'
import { encryptToken } from 'helpers/crypto'
import qs from 'qs'
import _ from 'lodash'

export function redirect (type, merchant, currentQuery, query = {}) {
  let p = {}
  const currentUrl = new URLParser(window.location.href)
  let path = `${currentUrl.url.protocol}//${currentUrl.url.host}`
  if (type === 'takeaway' && merchant.setting.customDirectoryTakeawayLink) {
    const customUrl = new URLParser(merchant.setting.customDirectoryTakeawayLink)
    path = `${customUrl.url.protocol}//${customUrl.url.host}${customUrl.url.pathname}`
    p = {
      ...p,
      ...customUrl.getParams(),
    }
  }
  if (type === 'sdelivery' && merchant.setting.customDirectorySdeliveryLink) {
    const customUrl = new URLParser(merchant.setting.customDirectorySdeliveryLink)
    path = `${customUrl.url.protocol}//${customUrl.url.host}${customUrl.url.pathname}`
    p = {
      ...p,
      ...customUrl.getParams(),
    }
  }

  p = {
    ...p,
    ...currentUrl.getParams(),
    [type]: true,
    // carry over coupon code
    ..._.get(currentQuery.params.c) && { c: _.get(currentQuery.params.c) },
    dir: undefined,
    f: undefined,
    ...query,
  }
  const params = qs.stringify(p)
  window.location.href = `${path}?x=${encryptToken(params)}`
}

export function goToShop (merchant) {
  let params = {}
  const currentUrl = new URLParser(window.location.href)
  let path = `${currentUrl.url.protocol}//${currentUrl.url.host}`
  if (merchant.setting.customDirectoryShopLink) {
    const customUrl = new URLParser(merchant.setting.customDirectoryShopLink)
    path = `${customUrl.url.protocol}//${customUrl.url.host}${customUrl.url.pathname}`
    params = {
      ...params,
      ...customUrl.getParams(),
    }
  }
  params = {
    ...params,
    ...currentUrl.getParams(),
    m: merchant.id,
    shop: true,
    dir: undefined,
  }
  params = qs.stringify(params)
  window.location.href = `${path}?x=${encryptToken(params)}`
}



// WEBPACK FOOTER //
// ./src/helpers/redirect.js